var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.welfare && _vm.welfare.iRet === 0 ? _c('div', {
    directives: [{
      name: "report",
      rawName: "v-report.pv",
      value: '福利社首页',
      expression: "'福利社首页'",
      modifiers: {
        "pv": true
      }
    }, {
      name: "report",
      rawName: "v-report.module",
      value: {},
      expression: "{}",
      modifiers: {
        "module": true
      }
    }],
    staticClass: "main"
  }, [_vm._l(_vm.welfare.vModList, function (item, key) {
    return [item.data.tModDescInfo.sZtLeafType === _vm.LeafType.Focus ? _c('Focus', {
      key: key,
      ref: item.data.tModDescInfo.sModId,
      refInFor: true,
      attrs: {
        "data": item.data,
        "id": "m".concat(item.data.tModDescInfo.sModId)
      }
    }) : _vm._e(), item.data.tModDescInfo.sZtLeafType === _vm.LeafType.QuickEntry ? _c('QuickEntry', {
      key: key,
      ref: item.data.tModDescInfo.sModId,
      refInFor: true,
      attrs: {
        "data": item.data,
        "id": "m".concat(item.data.tModDescInfo.sModId)
      }
    }) : _vm._e(), item.data.tModDescInfo.sZtLeafType === _vm.LeafType.BelongsWelfare ? _c('Exclusive', {
      key: key,
      ref: item.data.tModDescInfo.sModId,
      refInFor: true,
      attrs: {
        "data": item.data,
        "welfare": _vm.welfare,
        "id": "m".concat(item.data.tModDescInfo.sModId)
      }
    }) : _vm._e(), item.data.tModDescInfo.sZtLeafType === _vm.LeafType.SecondKill ? _c('SecondKill', {
      key: key,
      ref: item.data.tModDescInfo.sModId,
      refInFor: true,
      attrs: {
        "data": item.data,
        "id": "m".concat(item.data.tModDescInfo.sModId)
      }
    }) : _vm._e(), item.data.tModDescInfo.sZtLeafType === _vm.LeafType.NormalMod ? _c('div', {
      key: key
    }, [_c('NormalMod', {
      ref: item.data.tModDescInfo.sModId,
      refInFor: true,
      attrs: {
        "data": item.data,
        "id": "m".concat(item.data.tModDescInfo.sModId)
      }
    })], 1) : _vm._e(), _vm.isMounted ? [item.data.tModDescInfo.sZtLeafType === _vm.LeafType.OfflineAct ? _c('OfflineAct', {
      key: key,
      ref: item.data.tModDescInfo.sModId,
      refInFor: true,
      attrs: {
        "data": item.data,
        "id": "m".concat(item.data.tModDescInfo.sModId)
      }
    }) : _vm._e()] : _vm._e(), _vm.isMounted ? [item.data.tModDescInfo.sZtLeafType === _vm.LeafType.VipDiscounts ? _c('RenewMod', {
      key: key,
      ref: item.data.tModDescInfo.sModId,
      refInFor: true,
      attrs: {
        "data": item.data,
        "id": "m".concat(item.data.tModDescInfo.sModId)
      }
    }) : _vm._e()] : _vm._e(), item.data.tModDescInfo.sZtLeafType === _vm.LeafType.Placeholder && item.data.tModDescInfo.sCType === 'extend_modtype' ? _c('TabMod', {
      key: key,
      ref: item.data.tModDescInfo.sModId,
      refInFor: true,
      attrs: {
        "data": item.data,
        "id": "m".concat(item.data.tModDescInfo.sModId)
      }
    }) : _vm._e()];
  }), _c('Email'), _c('QmAdv')], 2) : _vm.error ? _c('Error', {
    attrs: {
      "enableBack": false,
      "message": '数据拉取失败，请点击刷新'
    }
  }) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };